/*
  Setas da galeria de fotos da PDP no mobile.

  No desktop a galeria e grade 2-up fixa (sem rolagem, sem seta). No celular
  ela vira trilho de toque, uma foto por vez (.brisa-galeria__quadro com 86%
  de largura). O dedo ja resolve, mas — mesmo raciocinio do brisa-trilho.js —
  sem seta a unica pista de que ha mais fotos e a beirada da proxima
  espiando, e o carrossel de imagem de produto normalmente tem espiada curta
  o bastante pra passar despercebida.

  So por acao do usuario: sem autoplay, sem biblioteca de carrossel. A
  rolagem nativa (scroll-snap) continua funcionando igual sem este arquivo.
*/
(() => {
  function ligar(galeria) {
    // o seletor de variante troca o HTML da galeria inteiro; sem esta marca o
    // religar empilharia um listener a cada clique de cor
    if (galeria.dataset.brisaLigada === '1') return;
    galeria.dataset.brisaLigada = '1';
    const trilho = galeria.querySelector('.brisa-galeria__grade');
    const antes = galeria.querySelector('[data-antes]');
    const depois = galeria.querySelector('[data-depois]');
    if (!trilho || !antes || !depois) return;

    const passo = () => {
      const foto = trilho.firstElementChild;
      if (!foto) return trilho.clientWidth;
      const gap = parseFloat(getComputedStyle(trilho).columnGap) || 0;
      return foto.getBoundingClientRect().width + gap;
    };

    const atualizar = () => {
      const sobra = trilho.scrollWidth - trilho.clientWidth;
      // 4px de folga: navegador arredonda o scrollLeft e a seta piscava no fim
      const temMais = sobra > 4;
      antes.hidden = !temMais;
      depois.hidden = !temMais;
      if (!temMais) return;
      antes.disabled = trilho.scrollLeft <= 4;
      depois.disabled = trilho.scrollLeft >= sobra - 4;
    };

    antes.addEventListener('click', () => trilho.scrollBy({ left: -passo(), behavior: 'smooth' }));
    depois.addEventListener('click', () => trilho.scrollBy({ left: passo(), behavior: 'smooth' }));
    trilho.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);

    atualizar();
  }

  const iniciar = () => document.querySelectorAll('[data-brisa-galeria]').forEach(ligar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // trocar de cor redesenha a galeria pela Section Rendering API: o HTML novo
  // chega sem listener nenhum, e as setas do mobile parariam de responder
  document.addEventListener('brisa:blocos-trocados', iniciar);
})();
